import AgendaListView from './AgendaListView';

export default AgendaListView;